import React from 'react';
import { Helmet as ReactHelmet } from '../Helmet';
import { BlogPost } from '../../types/blog';

interface ArticleSchemaProps {
    article: BlogPost;
}

export const ArticleSchema: React.FC<ArticleSchemaProps> = ({ article }) => {
    const articleSchema = (article as any).articleSchema;
    const faq = (article as any).faq;

    const blogPostingSchema = {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: article.title,
        description: article.excerpt,
        image: article.image,
        datePublished: article.date,
        dateModified: article.date,
        author: {
            '@type': 'Person',
            name: article.author,
        },
        publisher: {
            '@type': 'Organization',
            name: 'Upnov IA',
            logo: {
                '@type': 'ImageObject',
                url: 'https://www.upnov.com/favicon.svg',
            },
        },
        mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': article.seo.canonicalUrl,
        },
        keywords: article.tags.join(', '),
        articleSection: article.category,
    };

    return (
        <ReactHelmet>
            <script type="application/ld+json">
                {JSON.stringify(blogPostingSchema)}
            </script>

            {articleSchema && (
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'Article',
                        headline: articleSchema.headline,
                        description: articleSchema.description,
                        author: { '@type': 'Person', name: article.author },
                        publisher: { '@type': 'Organization', name: 'Upnov IA' },
                        datePublished: articleSchema.datePublished || article.date,
                        ...(articleSchema.about && { about: articleSchema.about }),
                    })}
                </script>
            )}

            {faq && faq.length > 0 && (
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'FAQPage',
                        mainEntity: faq.map((item: any) => ({
                            '@type': 'Question',
                            name: item.question,
                            acceptedAnswer: { '@type': 'Answer', text: item.answer },
                        })),
                    })}
                </script>
            )}
        </ReactHelmet>
    );
};
